import { lazy } from 'react'

import { SalaryAdvanceRootPageDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/salary_advance/pages/RootPage'))
const SummaryPage = lazy(() => import('modules/salary_advance/pages/SummaryPage'))
const RequestsPage = lazy(() => import('modules/salary_advance/pages/RequestPage'))
const EmployeesPage = lazy(() => import('modules/salary_advance/pages/EmployeesPage'))

export const salaryAdvanceRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.salaryAdvance.path,
    element: <RootPage />,
    handle: {
      module: 'salary_advance',
      moduleName: () => i18n.t('salary_advance.module_name'),
      meta: ({ watchQuery }) => {
        return watchQuery({
          query: SalaryAdvanceRootPageDocument,
        }).map(({ data }) => {
          const canManageSalaryAdvance = data?.salaryAdvance._policies.manageSalaryAdvance.can

          return {
            title: i18n.t('salary_advance.module_name'),
            settings: canManageSalaryAdvance
              ? navigation.settings.salaryAdvance.fullPath()
              : undefined,
            subNavigation: [
              {
                title: i18n.t('salary_advance.tabs.requests.title'),
                href: navigation.salaryAdvance.fullPath(),
                index: true,
              },
              {
                title: i18n.t('benefits.tabs.employees.page.title'),
                href: navigation.salaryAdvance.employees.fullPath(),
              },
              {
                title: i18n.t('salary_advance.tabs.summary.title'),
                href: navigation.salaryAdvance.summary.fullPath(),
              },
            ],
          }
        })
      },
    },
    children: [
      {
        index: true,
        element: <RequestsPage />,
      },
      {
        path: navigation.salaryAdvance.requests.path,
        element: <RequestsPage />,
      },
      {
        path: navigation.salaryAdvance.employees.path,
        element: <EmployeesPage />,
      },
      {
        path: navigation.salaryAdvance.summary.path,
        element: <SummaryPage />,
      },
    ],
  },
]
